import { render, staticRenderFns } from "./import-data-modal.vue?vue&type=template&id=07c0fc86&scoped=true&"
import script from "./import-data-modal.vue?vue&type=script&lang=js&"
export * from "./import-data-modal.vue?vue&type=script&lang=js&"
import style0 from "./import-data-modal.vue?vue&type=style&index=0&id=07c0fc86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c0fc86",
  null
  
)

export default component.exports